{
  "home.nav": "Home",
  "home.title": "Home",
  "home.greeting": "{greeting, select, morning {Good morning} afternoon {Good afternoon} other {Good evening}}, {name}",
  "home.subtitle": "Here is how work stands today, {date}.",
  "home.loadError": "We could not load your home page.",
  "home.portfolio.title": "Projects at a glance",
  "home.portfolio.active": "Active projects",
  "home.portfolio.onHold": "{count, plural, =0 {None on hold} one {# on hold} other {# on hold}}",
  "home.portfolio.open": "Open tasks",
  "home.portfolio.dueThisWeek": "{count, plural, =0 {No deadlines this week} one {# deadline this week} other {# deadlines this week}}",
  "home.portfolio.overdue": "Overdue tasks",
  "home.portfolio.done": "Done in 7 days",
  "home.focus.title": "Your focus",
  "home.focus.open": "My work",
  "home.focus.overdue": "Overdue",
  "home.focus.today": "Due today",
  "home.focus.week": "This week",
  "home.attention.title": "Projects that need attention",
  "home.attention.all": "All projects",
  "home.attention.lead": "Lead: {name}",
  "home.attention.healthy": "{count, plural, =0 {No other projects} one {# other project is on track} other {# other projects are on track}}",
  "home.attention.more": "{count, plural, =0 {No more projects need attention} one {# more project needs attention} other {# more projects need attention}}",
  "home.attention.allClear.title": "Every project is on track",
  "home.attention.allClear.body": "{count, plural, =0 {No running projects right now.} one {# running project, nothing to chase.} other {# running projects, nothing to chase.}}",
  "home.attention.noProjects.title": "No projects yet",
  "home.attention.noProjects.body": "Create a project and its health will show up here.",
  "home.attention.noProjects.memberBody": "Projects you are added to will show up here.",
  "home.workload.title": "Team workload",
  "home.workload.legendOpen": "Open",
  "home.workload.legendOverdue": "Overdue",
  "home.workload.open": "{count, plural, =0 {No tasks} one {# task} other {# tasks}}",
  "home.workload.overdue": "{count, plural, =0 {none late} one {# overdue} other {# overdue}}",
  "home.workload.dueThisWeek": "{count, plural, =0 {nothing due this week} one {# due this week} other {# due this week}}",
  "home.workload.empty.title": "No open work assigned",
  "home.workload.empty.body": "Once tasks are assigned, you will see who is carrying what.",
  "home.activity.title": "Recent activity",
  "home.activity.empty.title": "No activity yet",
  "home.activity.empty.body": "Changes to tasks and new comments in your projects will show up here.",
  "home.activity.showMore": "Show more",
  "home.activity.showLess": "Show less",
  "myWork.intro": "{greeting}. {count, plural, =0 {Nothing is assigned to you right now.} one {You have # open task.} other {You have # open tasks.}}",
  "myWork.overdueCount": "{count, plural, =0 {Nothing overdue} one {# overdue} other {# overdue}}",
  "myWork.loadError": "We could not load your work.",
  "myWork.section.overdue": "Overdue",
  "myWork.section.today": "Today",
  "myWork.section.week": "This week",
  "myWork.section.later": "Later",
  "myWork.section.review": "Waiting for review",
  "myWork.section.mentions": "Mentions",
  "myWork.mention.sentence": "{actor} mentioned you in a comment on {target}",
  "notifications.title": "Notifications",
  "notifications.bellLabel": "{count, plural, =0 {Notifications} one {Notifications, # unread} other {Notifications, # unread}}",
  "notifications.filterLabel": "Show",
  "notifications.filter.all": "All",
  "notifications.filter.unread": "Unread",
  "notifications.markAll": "Mark all as read",
  "notifications.markError": "We could not update your notifications. Try again.",
  "notifications.loadError": "We could not load your notifications.",
  "notifications.loadMore": "Load more",
  "notifications.loadingMore": "Loading…",
  "notifications.empty.title": "No notifications yet",
  "notifications.empty.body": "When someone assigns you a task, mentions you or moves your work along, you will see it here.",
  "notifications.emptyUnread.title": "You're all caught up",
  "notifications.emptyUnread.body": "Nothing unread. Earlier notifications are under All.",
  "notifications.unread": "Unread",
  "notifications.sentence.assigned": "{actor} assigned you {target}",
  "notifications.sentence.mentioned": "{actor} mentioned you in a comment on {target}",
  "notifications.sentence.commented": "{actor} commented on {target}",
  "notifications.sentence.statusChanged": "{actor} moved {target} to {status}",
  "notifications.sentence.updated": "{actor} updated {target}",
  "notifications.sentence.memberAdded": "{actor} added you to {target}{role, select, lead { as its lead} contributor { as a contributor} viewer { as a viewer} other {}}",
  "comments.title": "Comments and activity",
  "comments.label": "Write a comment",
  "comments.placeholder": "Write a comment… Type @ to mention someone",
  "comments.send": "Send",
  "comments.sendHint": "to send",
  "comments.sending": "Sending…",
  "comments.readOnly": "You can follow this conversation, but you cannot comment in this project.",
  "comments.forbidden": "You cannot comment on this task.",
  "comments.postError": "Your comment was not sent. It is back in the box so you can try again.",
  "comments.editError": "Your edit was not saved. Try again.",
  "comments.loadError": "We could not load the conversation.",
  "comments.empty": "No comments yet. Start the conversation below.",
  "comments.edited": "(edited)",
  "comments.deleted": "This comment was deleted.",
  "comments.actions": "Comment actions",
  "comments.edit": "Edit",
  "comments.editLabel": "Edit your comment",
  "comments.save": "Save",
  "comments.delete": "Delete",
  "comments.deleting": "Deleting…",
  "comments.deleteTitle": "Delete this comment?",
  "comments.deleteBody": "Its text is removed for everyone. The thread keeps a note that a comment was deleted.",
  "comments.by": "Comment by {name}",
  "comments.mention.heading": "Mention someone",
  "activity.someone": "Someone",
  "activity.someMember": "a member",
  "activity.thisTask": "this task",
  "activity.showEarlier": "Show earlier activity",
  "activity.task.created": "{actor} created {target}",
  "activity.task.moved": "{actor} moved {target} to {status}",
  "activity.task.assigned": "{actor} assigned {target} to {name}",
  "activity.task.assignedYou": "{actor} assigned {target} to you",
  "activity.task.assignedSelf": "{actor} took {target}",
  "activity.task.assignedSomeone": "{actor} assigned {target} to a teammate",
  "activity.task.unassigned": "{actor} unassigned {target}",
  "activity.task.unassignedPerson": "{actor} took {name} off {target}",
  "activity.task.unassignedYou": "{actor} took you off {target}",
  "activity.task.unassignedSelf": "{actor} left {target}",
  "activity.task.cancelled": "{actor} cancelled {target}",
  "activity.task.restored": "{actor} reopened {target}",
  "activity.task.updated": "{actor} updated {target}",
  "activity.task.renamed": "{actor} renamed {target} to {title}",
  "activity.task.dueSet": "{actor} set the due date of {target} to {date}",
  "activity.task.dueCleared": "{actor} removed the due date of {target}",
  "activity.task.startSet": "{actor} set the start date of {target} to {date}",
  "activity.task.startCleared": "{actor} removed the start date of {target}",
  "activity.task.prioritySet": "{actor} set the priority of {target} to {priority}",
  "activity.task.estimateChanged": "{actor} changed the estimate of {target}",
  "activity.task.descriptionChanged": "{actor} updated the description of {target}",
  "activity.comment.created": "{actor} commented on {target}",
  "activity.project.created": "{actor} created the project {target}",
  "activity.project.updated": "{actor} updated the details of {target}",
  "activity.project.statusChanged": "{actor} changed the status of {target} to {status}",
  "activity.project.memberAdded": "{actor} added {name} to {target}",
  "activity.project.memberAddedYou": "{actor} added you to {target}",
  "activity.project.memberRoleChanged": "{actor} made {name} {role, select, lead {the lead} contributor {a contributor} viewer {a viewer} other {a member}} of {target}",
  "activity.project.memberRemoved": "{actor} removed {name} from {target}",
  "activity.project.changed": "{actor} made a change in {target}",
  "search.tasks": "Tasks",
  "search.clients": "Clients",
  "search.people": "People",
  "search.loading": "Searching…",
  "home.portfolio.newThisWeek": "{count, plural, =0 {Nothing new in 7 days} one {# new in 7 days} other {# new in 7 days}}",
  "home.delta.vsPrevious": "vs the week before",
  "home.delta.up": "{count, plural, one {# more} other {# more}} than in the 7 days before",
  "home.delta.down": "{count, plural, one {# fewer} other {# fewer}} than in the 7 days before",
  "home.delta.same": "The same as in the 7 days before",
  "home.throughput.title": "Work completed",
  "home.throughput.description": "Tasks done each week over the last 8 weeks",
  "home.throughput.thisWeek": "This week so far",
  "home.throughput.lastWeek": "Last week",
  "home.throughput.average": "Weekly average",
  "home.throughput.current": "This week",
  "home.throughput.weekOf": "Week of {date}",
  "home.throughput.tooltip": "{count, plural, =0 {No tasks done} one {# task done} other {# tasks done}}",
  "home.throughput.tableCaption": "Tasks completed per week, last 8 weeks",
  "home.throughput.columnWeek": "Week starting",
  "home.throughput.columnDone": "Tasks completed",
  "home.throughput.empty": "Nothing completed in the last 8 weeks yet.",
  "home.status.title": "Open work by status",
  "home.status.description": "{count, plural, =0 {No open tasks in active projects} one {# open task in active projects} other {# open tasks in active projects}}",
  "home.status.empty": "Nothing is open. New tasks will show up here as they are planned.",
  "activity.file.attached": "{actor} attached {name} to {target}",
  "activity.file.versionAdded": "{actor} uploaded version {version} of {name} to {target}",
  "activity.file.removed": "{actor} removed {name} from {target}",
  "comments.attach": "Attach files",
  "comments.attachHint": "or paste a screenshot",
  "comments.attachments": "Files in this comment",
  "comments.attachmentsBusy": "Wait until the files finish uploading.",
  "comments.removeAttachment": "Remove {name}",
  "myWork.tabs.label": "My work views",
  "myWork.tab.assigned": "Assigned to me",
  "myWork.tab.review": "Waiting for my review",
  "myWork.side.label": "Your week",
  "myWork.week.title": "Your week",
  "myWork.week.free": "Nothing due",
  "myWork.week.more": "{count, plural, one {+# more} other {+# more}}",
  "myWork.time.title": "Your time this week",
  "myWork.time.open": "Open the timesheet",
  "myWork.empty.assigned.title": "Nothing is assigned to you",
  "myWork.empty.assigned.body": "When someone gives you a task it lands here, sorted by when it is due.",
  "myWork.empty.review.title": "Nothing waits for your review",
  "myWork.empty.review.body": "Tasks you created show up here when they reach review.",
  "myWork.empty.mentions.title": "No mentions",
  "myWork.empty.mentions.body": "When a teammate mentions you in a comment, it shows up here.",
  "myWork.tile.none": "None",
  "home.deadlines.title": "Upcoming deadlines",
  "home.deadlines.description": "Running projects by end date",
  "home.deadlines.left": "{count, plural, =0 {Ends today} one {# day left} other {# days left}}",
  "home.deadlines.late": "{count, plural, one {# day late} other {# days late}}",
  "home.deadlines.empty.title": "No end dates yet",
  "home.deadlines.empty.body": "Give running projects an end date and they will line up here.",
  "notifications.sentence.approvalApproved": "{actor} approved {target}",
  "notifications.sentence.approvalChangesRequested": "{actor} asked for changes to {target}",
  "notifications.sentence.unblocked": "{actor} finished {blocker}, so {target} is ready to start",
  "activity.task.dependencyAdded": "{actor} marked {target} as waiting on another task",
  "activity.task.dependencyRemoved": "{actor} removed a blocker from {target}",
  "activity.task.unblocked": "{target} is no longer blocked",
  "activity.task.recurrenceSet": "{actor} set {target} to repeat",
  "activity.task.recurrenceStopped": "{actor} stopped {target} repeating",
  "activity.task.labelsChanged": "{actor} changed the labels on {target}",
  "activity.task.milestoneChanged": "{actor} changed the milestone of {target}",
  "activity.task.phaseChanged": "{actor} changed the phase of {target}",
  "activity.milestone.created": "{actor} added the milestone {target}",
  "activity.milestone.updated": "{actor} edited the milestone {target}",
  "activity.milestone.completed": "{actor} marked the milestone {target} as reached",
  "activity.milestone.reopened": "{actor} reopened the milestone {target}",
  "activity.milestone.deleted": "{actor} deleted the milestone {target}",
  "activity.milestone.phasesAdded": "{actor} added {count, plural, one {# phase} other {# phases}} to {target}",
  "activity.phase.created": "{actor} added the phase {name} to {target}",
  "activity.phase.updated": "{actor} edited the phase {name} in {target}",
  "activity.phase.deleted": "{actor} deleted the phase {name} from {target}"
}
